// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DuB_","col":"styles_col__34-v-"};